import { isEqual } from 'underscore';
import { Dispatch, ThunkAction } from '../../../../types/actions';
import { IGetState, TBoardId, TListId } from '../../../../types/types';
import { clickManagerActionSet } from '../store/clickManager/actions/clickManagerActionSet';
import { getSelectedLists } from '../selectors/getSelectedLists';
import { selectedListIdsSet } from '../store/clickManagerModel/actions/selectedListIdsSet';
import { getIsListMultiselect } from '../selectors/getIsListMultiselect';

export const updateSelectedLists = (
    boardId: TBoardId,
    selectedLists: TListId[],
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const isMultiselect = getIsListMultiselect(state, boardId) || selectedLists.length > 1;
        const selectedListsState = getSelectedLists(getState(), boardId);
        if (!isEqual(selectedLists, selectedListsState)) { // dispatches optimization
            dispatch(clickManagerActionSet(boardId, selectedListIdsSet(selectedLists, isMultiselect)));
        }
    };
    return action;
};
